import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import VideoEmbed from '../global/VideoEmbed'
import { P } from 'components/typography/Paragraph'

interface Props {
	standard?: 'CCSS' | 'TEKS'
	language?: 'english' | 'spanish'
}

const ForTabs = ({ standard = 'CCSS', language = 'english' }: Props) => {
	return (
		<Fade bottom>
			<Tabs selectedTabClassName="text-ab-100 border-ab-100">
				<TabList className="mb-6 flex flex-wrap gap-4 px-4">
					<Tab className="mb-6 min-w-max flex-1 cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">For Teachers</Tab>
					<Tab className="mb-6 min-w-max flex-1 cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">For Students</Tab>
					<Tab className="mb-6 min-w-max flex-1 cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">For School Leaders</Tab>
					<Tab className="mb-6 min-w-max flex-1 cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">For Families</Tab>
				</TabList>
				{/* For Teachers */}
				<TabPanel>
					<Tabs selectedTabClassName="text-slate-600 border-slate-600">
						<TabList className="mx-auto mb-6 flex w-full flex-wrap gap-5  px-4 sm:w-7/12">
							<Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">
								SchoolPace<sup>®</sup>
							</Tab>
							<Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">myARC</Tab>
						</TabList>
						<TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">SchoolPace for Teachers</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										SchoolPace offers teachers classroom data that reveals what every student needs to learn next, as well as the tools and resources for
										effective instruction.
									</P>
									<img src="/images/digital-solutions/schoolpace-for-teachers.png" alt="schoolpace connect" />
								</div>
							</div>
						</TabPanel>
						<TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">myARC for Teachers</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										myARC provides teachers with digital access to teacher guides and other curricular materials for effective instruction.
									</P>
									<img src="/images/digital-solutions/myarc-for-teachers.png" alt="schoolpace connect" />
								</div>
							</div>
						</TabPanel>
					</Tabs>
				</TabPanel>
				{/* For Students */}
				<TabPanel>
					<Tabs selectedTabClassName="text-slate-600 border-slate-600">
						<TabList className="mx-auto mb-6 flex w-full flex-wrap gap-5 px-4 sm:w-7/12">
							<Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">myARC</Tab>
							<Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">ARC Bookshelf</Tab>
							<Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">
								ARC Reads<sup>®</sup>
							</Tab>
							{/* <Tab className="mb-6 min-w-max flex-1 cursor-pointer border-b py-3 text-center hover:border-b-slate-600">
								ARC Adventures<sup>®</sup>
							</Tab> */}
						</TabList>
						<TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">myARC for Students</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										myARC ensures every student receives instruction tailored to their needs.
									</P>
									<img src="/images/digital-solutions/myarc-for-students.png" alt="schoolpace connect" />
								</div>
							</div>
						</TabPanel>
						<TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">
								{language === 'english' ? <span>ARC Bookshelf for Students</span> : <span>ARC Bookshelf para estudiantes</span>}
							</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										{language === 'english'
											? 'ARC Bookshelf supports daily reading practice with engaging eBooks students can and want to read at school, at home, and anywhere in between.'
											: 'ARC Bookshelf apoya la práctica de lectura diaria con libros digitales atrayentes que los estudiantes podrán y querrán leer en la escuela, el hogar o en su tiempo libre.'}
									</P>
									<img src="/images/digital-solutions/bookshelf-for-students.png" alt="schoolpace connect" className="mx-auto max-w-5xl" />
								</div>
							</div>
						</TabPanel>
						<TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">ARC Reads for Students</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										ARC Reads promotes student agency by giving students access to interactive assignments, a digital logging solution, and tools to establish a
										baseline for their independent reading.
									</P>
									<img src="/images/digital-solutions/arc-reads-for-students.png" alt="arc reads platform" />
								</div>
							</div>
						</TabPanel>
						{/* <TabPanel>
							<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">ARC Adventures for Students</span>
							<div className="px-6 pb-6">
								<div>
									<P shade="darker" className="mx-auto max-w-3xl text-center">
										ARC Adventures is an educational video game designed to help students practice the 1G power words outlined in the IRLA.
									</P>
									<img src="/images/digital-solutions/arc-adventures-for-students.png" alt="schoolpace connect" className="mx-auto max-w-5xl" />
								</div>
							</div>
						</TabPanel> */}
					</Tabs>
				</TabPanel>
				{/* For Schools */}
				<TabPanel>
					<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">
						{language === 'english' ? 'SchoolPace for Schools' : 'SchoolPace para escuelas'}
					</span>
					<div>
						<P shade="darker" className="mx-auto max-w-3xl text-center">
							{language === 'english'
								? 'SchoolPace provides school leaders with real-time insights into student data at the school and district levels, with dashboards to track key metrics and drivers of success, empowering all stakeholders to identify where support and intervention are needed most.'
								: 'SchoolPace provee información en tiempo real a los líderes del distrito, proveyéndoles datos estudiantiles a nivel escolar y de distrito, tableros para rastrear los índices de rendimiento y progreso, confiriendo a las partes interesadas la posibilidad de identificar aquellas áreas que necesitan más apoyo e intervención.'}
						</P>
						{standard === 'TEKS' ? (
							<img src="/images/digital-solutions/for-schools.png" alt="for schools" />
						) : (
							<VideoEmbed title="SchoolPace Connect for Schools" src="https://player.vimeo.com/video/491771258" />
						)}
					</div>
				</TabPanel>
				{/* For Families */}
				<TabPanel>
					<span className="mx-auto mb-2 block w-full max-w-xl text-center text-3xl font-medium text-ab-100 sm:text-4xl">
						{language === 'english' ? 'Home Updates' : 'SchoolPace Connect para familias'}
					</span>
					<div>
						<P shade="darker" className="mx-auto max-w-3xl text-center">
							{language === 'english'
								? 'Home updates provide families with clear, user-friendly information (in English and Spanish) and the tools and resources to help their children learn.'
								: 'SchoolPace Connect les brinda a las familias información clara y fácil de usar (en inglés y español), así como las herramientas y recursos para apoyar a sus hijos en su aprendizaje.'}
						</P>
						{standard === 'TEKS' ? (
							<img src="/images/digital-solutions/for-families.png" alt="for families" />
						) : (
							<VideoEmbed title="SchoolPace Connect for Families" src="https://player.vimeo.com/video/491770096" />
						)}
					</div>
				</TabPanel>
			</Tabs>
		</Fade>
	)
}

export default ForTabs
